// CustomEditorCateList.js
import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  CardBody,
  CardTitle,
  Button,
  Row,
  Col,
  Input
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";

// Custom CSS
import "./CustomEditorCateList.css";

import library2 from "assets/images/info/library2.png";

import BreadcrumbAboveImage from "components/Common/BreadcrumbAboveImage";
import CardCarousel from './components/CardCarousel';
import CardSubCarousel from './components/CardSubCarousel';

const cards = [
  { id: 1, title: "題組型", subtitle: "（有標準答案）", color: "#f9c74f" },
  { id: 2, title: "題組型", subtitle: "（無標準答案）", color: "#f9844a" },
  { id: 3, title: "圖文型", subtitle: "（有標準答案）", color: "#90be6d" },
  { id: 4, title: "圖文型", subtitle: "（無標準答案）", color: "#577590" },
];

const cards_subcategories = {
  1: [
    { order: 1, title: "考試", color: "#f9c74f",
      description: ["不顯示題組內狀態", "不顯示結果統計", "預設初始顯示所有題目", "預設無獎勵"]
    },
    { order: 2, title: "趣味問答", color: "#f9c74f",
      description: ["顯示題組內狀態", "顯示結果統計", "預設初始顯示所有題目", "預設有獎勵"] 
    },
  ],
  2: [{ order: 1, title: "調查", color: "#f9844a",
      description: ["（有標準答案）"] 
  }],
  3: [{ order: 1, title: "解說", color: "#90be6d",
      description: ["（無標準答案）"]  
  }],
  4: [{ order: 1, title: "廣告", color: "#577590",
      description: ["（有標準答案）"]  
  }],
};

/*----------------------
/* Main Component
/*----------------------*/

const CustomEditorCateList = ({ t }) => {

  const navigate = useNavigate();

  //--------------------------------------------------
  // States
  //--------------------------------------------------
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeSubIndex, setActiveSubIndex] = useState(0);

  //--------------------------------------------------
  // Render
  //--------------------------------------------------
  return (
    <React.Fragment>
      <div className="page-content" 
        style={{ 
          minHeight: "100vh",
          backgroundImage: `url(${library2})`,
          paddingBottom: "25px",
        }}
      >

        <BreadcrumbAboveImage
          title={t("My Info")}
          breadcrumbItems={[
            { title: t("我的 AI 應用主頁"), to: "/myInfo/dashboard" },
            { title: t("新增題組") }
          ]}
        />

        <Container fluid>
          <Card>
            <CardBody style={{ minHeight: "75vh" }}>

              <CardCarousel 
                cards={cards}
                activeIndex={activeIndex}
                setActiveIndex={setActiveIndex}
              />

              {/* Mask Style */}
              {/*
              <div
                style={{
                  width: "100%",
                  height: "2px", // total height to work with
                  background: `
                    linear-gradient(
                      to right,
                      transparent 0%,
                      #999 20%,
                      #333 50%,
                      #999 80%,
                      transparent 100%
                    )
                  `,
                  maskImage: "radial-gradient(ellipse at center, black 0%, transparent 70%)",
                  WebkitMaskImage: "radial-gradient(ellipse at center, black 0%, transparent 70%)",
                  margin: "16px 0",
                }}
              ></div>
              */}

              <svg 
                className="horizonal-svg"
                width="80%" height="25" viewBox="0 0 100 40" preserveAspectRatio="none"
                style={{
                  display: "block",        // prevents unwanted bottom spacing
                }}
              >
                <defs> 
                  <linearGradient id="ribbonGradient" x1="0%" y1="0%" x2="100%" y2="0%"> 
                    <stop offset="0%" stopColor="#c7daeb" /> 
                    <stop offset="20%" stopColor="#81a3c2" /> 
                    <stop offset="50%" stopColor="#577590" /> 
                    <stop offset="80%" stopColor="#81a3c2" /> 
                    <stop offset="100%" stopColor="#c7daeb" /> 
                  </linearGradient> 
                </defs> 
                <path
                  d="
                    M0,4
                    L0,2
                    Q50,1 100,2
                    L100,4
                    Q50,5 0,4
                    Z
                  "
                  fill="url(#ribbonGradient)"
                />
              </svg>

              {cards[activeIndex].id && (() => {
                const realSubCards = cards_subcategories[cards[activeIndex].id] || [];
                // Clone the real cards to avoid mutation
                const subCards = [...realSubCards];
                const placeholder_color = cards[activeIndex].color;
                // Add placeholders if needed
                if (subCards.length === 0) {
                  subCards.push(
                    { order: 98, title: "佔位卡", description: [], isPlaceholder: true, color: placeholder_color },
                    { order: 99, title: "佔位卡", description: [], isPlaceholder: true, color: placeholder_color }
                  );
                } else {
                  subCards.push({ order: 99, title: "佔位卡", description: [], isPlaceholder: true , color: placeholder_color});
                }
                return (
                  <CardSubCarousel
                    subCards={subCards}
                    activeIndex={activeIndex}
                    setActiveIndex={setActiveIndex}
                    activeSubIndex={activeSubIndex}
                    setActiveSubIndex={setActiveSubIndex}
                  />
                );
              })()}

            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default withTranslation()(CustomEditorCateList);


